export default __webpack_public_path__ + "static/media/45k.61a8088b.md";